import apiClient from '../utils/apiService';

export const authApi = {
  updateQueryModel: (queryModelId) => apiClient.put('/prime/auth/query-model', { queryModelId }),
};

export default authApi;
